var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.112 6.666H8.89v2.222h2.222V6.666zm4.445 0h-2.222v2.222h2.222V6.666zm3.333 7.222c-1.333 0-2.668-.221-3.999-.665-.335-.113-.78 0-1.113.22l-2.445 2.446C8.225 14.333 5.666 11.667 4 8.555L6.444 6.11c.335-.332.446-.776.223-1.11-.334-1.224-.555-2.556-.555-3.89C6.112.443 5.666 0 5 0H1.111C.444 0 0 .443 0 1.11 0 11.556 8.446 20 18.89 20c.666 0 1.11-.446 1.11-1.111V15c0-.667-.444-1.112-1.11-1.112m-1.111-5H20V6.666H17.78v2.222z",
    fillRule: "nonzero"
  })));
};
export default SvgPhone;